export async function processLocalVideo(
  file: File
): Promise<{ duration: number; thumbnailDataUrl: string }> {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video')
    video.preload = 'metadata'
    video.src = URL.createObjectURL(file)
    video.muted = true
    video.playsInline = true

    video.onloadedmetadata = () => {
      // Seek to 1 second in, or halfway if it's a super short clip
      video.currentTime = Math.min(1, video.duration / 2)
    }

    video.onseeked = () => {
      const canvas = document.createElement('canvas')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      const ctx = canvas.getContext('2d')
      ctx?.drawImage(video, 0, 0, canvas.width, canvas.height)

      const thumbnailDataUrl = canvas.toDataURL('image/jpeg', 0.7) // 70% quality JPEG
      URL.revokeObjectURL(video.src) // Clean up memory

      resolve({
        duration: video.duration,
        thumbnailDataUrl
      })
    }

    video.onerror = (e) => reject(e)
  })
}
